import { Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { InsightsServiceApi } from './insights.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as pbi from 'powerbi-client';
import { UtilsService } from '../../services/utils.service';
import { DownloadFileService } from '../../services/downloadFile.service';



@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrl: './insights.component.scss',
  standalone: false
})
export class InsightsComponent implements OnInit {


  @ViewChild('powerBIContainer', { static: true }) powerBIContainer!: ElementRef;
  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  router: any;
  showBoolean: boolean;
  regions: any = [];
  productLines: any = [];
  requstList: any = [];
  message: boolean = false;
  visualForm: FormGroup;
  selectedRegion: any;
  selectedProductLine: string[] = [];
  selectedRequest1: any;
  selectedRequest2: any;
  embadedURL: any;
  embedToken: any;
  reportId: any;
  fileName: any;
  request2Type: any;
  isReportVisible: boolean = true;
  uploadedFile: any;
  isFileUploaded: boolean = false;
  isPLDisabled: boolean = true;
  isPR1Disabled: boolean = true;
  isPR2Disabled: boolean = true;
  isFileUploadDisabled: boolean = true;
  isSubmitDisabled: boolean = true;
  retryCount = 0;
  maxRetries = 10;
  getSharingErorr: any
  isShowErrorMessageWithToast: boolean;
  displayStyle: string;
  isSKUAllowed: boolean = false;
  isPriceFXLoaderAllowed: boolean = false;
  isCoverageReportAllowed: boolean = false;

  // Tab management
  activeTab: string = 'insights';

  isConfirmationPopupVisibale: boolean;
  popupMessage: any;
  isSuccessToast: boolean = true;
  errorFlag: boolean = false;
  fileError: any;
  getFileSize: any;
  uploadProgress = 0;
  uploadInProgress = false;
  getSharingError: any;


  constructor(
    private readonly insightsServiceApi: InsightsServiceApi,
    private readonly spinnerService: NgxSpinnerService,
    private fb: FormBuilder,
    private readonly utilService: UtilsService,
    private readonly downloadFileService: DownloadFileService
  ) {

  }

  ngOnInit() {

    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingErorr = res;
    });
    this.getRegionDetails();
    this.requestSubmitted = false;
    this.buildForm();
    this.embadedDashboard();

    this.utilService.SharingData.subscribe((res: any) => {
      this.getSharingError = res;
    });
    const insightSubModuleArray = JSON.parse(sessionStorage.getItem('insightSubModule') || '[]');
    
    if (insightSubModuleArray.includes('PriceFx Loader')) {
      this.isPriceFXLoaderAllowed = true;
    }

    if (insightSubModuleArray.includes('SKU Generator')) {
      this.isSKUAllowed = true;
    }
    if (insightSubModuleArray.includes('Coverage Report')) {
      this.isCoverageReportAllowed = true;
    }
  }

  isPLOpen = false
  isRegionOpen = false
  isPR1Open = false
  isPR2Open = false

  requestSubmitted = false

  openPL() {
    this.isPLOpen = !this.isPLOpen
    this.isRegionOpen = false
    this.isPR1Open = false
    this.isPR2Open = false
  }

  openReg() {
    this.isPLOpen = false
    this.isRegionOpen = !this.isRegionOpen
    this.isPR1Open = false
    this.isPR2Open = false
  }

  openPR1() {
    this.isPLOpen = false
    this.isRegionOpen = false
    this.isPR1Open = !this.isPR1Open
    this.isPR2Open = false
  }

  openPR2() {
    this.isPLOpen = false
    this.isRegionOpen = false
    this.isPR1Open = false
    this.isPR2Open = !this.isPR2Open
  }

  // Tab management methods
  setActiveTab(tab: string) {
    this.activeTab = tab;
    // Clear data when switching tabs
    this.clearAllData();
  }

  buildForm() {
    this.visualForm = this.fb.group({
      userId: [''],
      productLine: [[]],
      region: [[]],
      compareRequest1: [''],
      compareRequest2Type: [''],
      compareRequest2: ['']
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      this.uploadedFile = input.files[0];
      this.getFileSize = input.files[0].size;
      this.uploadReport();
    }
  }

  private handlePopupMessage(isShowPopupMessage: boolean, message: string, isSuccess: boolean) {
    if (isShowPopupMessage) {
      this.isReportVisible = false;
      this.popupMessage = message
      this.isSuccessToast = isSuccess;
      this.displayStyle = 'none';
      this.isConfirmationPopupVisibale = true;
      this.isShowErrorMessageWithToast = true;
      this.utilService.isTosterVisible(true, message);
      setTimeout(() => {
        this.isShowErrorMessageWithToast = false;
        this.utilService.isTosterVisible(false, '');
        this.embadedDashboard();
      }, 5000);

    } else {
      this.isShowErrorMessageWithToast = false;
    }
  }
  actionOnConfirmation() {

    this.selectedProductLineIds.set([]);
    this.selectedRegions.set([]);
    this.selectedPR1.set({ requestId: '', label: '' });
    this.selectedPR2.set({ requestId: '', label: '' });
    this.fileInputRef.nativeElement.value = '';
    this.selectedRegion = '';
    this.selectedProductLine = [];
    this.selectedRequest1 = '';
    this.selectedRequest2 = '';
    this.request2Type = '';
    this.isFileUploaded = false;
    this.displayStyle = 'none';

  }

  // regions call
  getRegionDetails() {
    this.insightsServiceApi
      .getRegions()
      .subscribe(
        (res) => {
          const regionLsts = res;
          this.regions = regionLsts.result;
          this.regions = this.regions.filter(function (el: any) {
            return el !== 'NULL';
          });
          this.showBoolean = false;
        },
        (err) => {
          this.spinnerService.hide();
          this.showBoolean = true;
        }
      );
  }

  getProductLineDetails(regionCodeOnEdit: any) {
    this.insightsServiceApi
      .getProductLines(
        regionCodeOnEdit
      )
      .subscribe(
        (res) => {
          const productLineLists = res;
          this.productLines = productLineLists.result;
          this.productLines = this.productLines.filter(function (el: any) {
            return el !== 'NULL';
          });

          //this.isProductLineDisabledOnRegion = true;
          return this.productLines;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  getPairingRquest() {
    const productLineCodes = this.selectedProductLineIds()
      .map(desc => this.getPLCodeByDescription(desc))
      .filter((c): c is string => !!c);
    this.selectedProductLine = productLineCodes;
    this.insightsServiceApi
      .getPairingRequest(this.selectedRegion, productLineCodes)
      .subscribe(
        (res) => {
          const requestLists = res;
          this.requstList = requestLists.result;
          this.requstList = this.requstList.filter(function (el: any) {
            return el !== 'NULL';
          });


          return this.requstList;
        },
        (err) => {
          this.spinnerService.hide();
        }
      );
  }

  embedPowerBIReport() {
    const embedConfig: pbi.IEmbedConfiguration = {
      type: 'report',
      id: this.reportId,
      embedUrl: this.embadedURL,
      tokenType: pbi.models.TokenType.Embed,
      accessToken: this.embedToken,
      permissions: pbi.models.Permissions.All,
      settings: {
        filterPaneEnabled: true,
        navContentPaneEnabled: true,
      },
    };

    const reportContainer = document.getElementById('report-container');

    if (reportContainer && (window as any).powerbi) {
      const report = (window as any).powerbi.embed(reportContainer, embedConfig);
      
      report.on('error', (event: any) => {
        console.error('Power BI embed error:', event.detail);
      });
    } else {
      console.error('Power BI container or SDK not found');
    }
  }


  embadedDashboard() {
    //this.simulateUpload();
    this.insightsServiceApi.embadedDashboard()
      .subscribe(
        (res: any) => {

          this.embadedURL = res.result.embedUrl;
          this.embedToken = res.result.embedToken;
          this.reportId = res.result.reportId;
          this.embedPowerBIReport();
        },
        (err: any) => {
          //console.log(err);
        }
      );
  }

  uploadReport() {
    let formData = new FormData();

    formData.append('file', this.uploadedFile);
    formData.append('userId', sessionStorage.getItem('userId'));
    formData.append('productLineCode', this.selectedProductLine[0] || '');
    formData.append('regionCode', this.selectedRegion);
    formData.append('module', null);

    this.insightsServiceApi.uploadReport(formData).subscribe(
      (response: any) => {
        this.spinnerService.hide();
        const getFileResponse: any = response;
        if (getFileResponse.body.message === 'OK') {
          this.isFileUploaded = true;
          this.errorFlag = false;
          this.fileError = '';

          this.isSubmitDisabled = false;
          this.fileName = getFileResponse.body.result;
        } else {
          this.errorFlag = true;
          this.fileError = getFileResponse.body.message;
        }
      },
      (error: any) => {
        const uploadError = this.getSharingError;
        this.utilService.SharingData.next(null);
        this.errorFlag = true;
        this.fileError = uploadError;
      }
    );
  }

  refreshDashboard() {
    if (this.retryCount >= this.maxRetries) {
      this.isReportVisible = false;
      this.handlePopupMessage(true, 'Maximum retry attempts(5) reached. Stopping refresh.', false);
      return;
    }
    this.insightsServiceApi.refreshDashboard()
      .subscribe(
        (res: any) => {
          if (res.result.status === 'Completed') {
            this.isReportVisible = true;
            this.isSubmitDisabled = false;
            this.embadedDashboard();
          } else if (res.result.status === 'InProgress' || res.result.status === 'Unknown') {
            this.isSubmitDisabled = true;
            //console.log(this.retryCount);
            this.retryCount++;
            setTimeout(() => {
              this.refreshDashboard();
              this.isReportVisible = false;
            }, 60000);
          } else if (res.result.status === 'Failed' || res.result.status === 'Cancelled') {
            this.isSubmitDisabled = false;
            this.handlePopupMessage(true, res.message, false);
          }
        },
        (err: any) => {
          //console.log(err);
        }
      );
  }

  reqSubmit() {
    this.requestSubmitted = true;
    let request2: any;
    if (this.fileName && this.fileName !== '') {
      this.request2Type = 'UPLOAD';
      request2 = this.fileName;
    } else {
      this.request2Type = 'Pairing Request';
      request2 = 'PAIR-' + this.selectedRequest2;
    }


    this.selectedProductLine = this.selectedProductLine.map(code => code === 'TC' ? 'PCLT' : code);

    this.visualForm.patchValue({
      userId: sessionStorage.getItem('userId'),
      productLine: this.selectedProductLine,
      region: this.selectedRegion,
      compareRequest1: 'PAIR-' + this.selectedRequest1,
      compareRequest2Type: this.request2Type,
      compareRequest2: request2
    });

    if ('PAIR-' + this.selectedRequest1 === request2) {
      this.handlePopupMessage(true, 'Both requests must not be same.', false);
    } else {
      this.isSubmitDisabled = true;
      this.insightsServiceApi
        .onSubmit(this.visualForm.value)
        .subscribe(
          (res: any) => {
            if (res.result.status === 'Visualization Request Submitted Successfully!') {
              this.handlePopupMessage(true, res.result.status, true);
              this.isReportVisible = false;
              this.refreshDashboard();
            } else {
              this.handlePopupMessage(true, 'No Records Found', false);
            }
          },
          (err: any) => {
            this.isReportVisible = false;
            setTimeout(() => {
              this.embadedDashboard();
              this.isReportVisible = true;
            }, 5000);
          }
        );
    }

  }


  selectedProductLineIds = signal<string[]>([]);
  selectedRegions = signal<string[]>([]);
  selectedPR1 = signal<{ requestId: string; label: string } | null>(null);
  selectedPR2 = signal<{ requestId: string; label: string } | null>(null);

  togglePLSelection(name: string) {
    const MULTI_SELECT_CODES = ['CT', 'MIN'];
    const code = this.getPLCodeByDescription(name);

    if (code && MULTI_SELECT_CODES.includes(code)) {
      // Multi-select: toggle within CT/MIN selections, clear any non-CT/MIN previously selected
      const current = this.selectedProductLineIds().filter(desc => {
        const c = this.getPLCodeByDescription(desc);
        return c && MULTI_SELECT_CODES.includes(c);
      });
      if (current.includes(name)) {
        const updated = current.filter(d => d !== name);
        this.selectedProductLineIds.set(updated);
        if (updated.length === 0) {
          this.selectedProductLine = [];
          this.isPR1Disabled = true;
          this.isPR2Disabled = true;
          this.isFileUploadDisabled = true;
          this.isSubmitDisabled = true;
          return;
        }
      } else {
        this.selectedProductLineIds.set([...current, name]);
      }
      // Keep dropdown open for multi-select
    } else {
      this.clearData('productLine');
      this.selectedProductLineIds.set([name]);
      this.isPLOpen = false;
      this.selectedProductLine = [this.getPLCodeByDescription(name)].filter((c): c is string => !!c);
    }

    this.getPairingRquest();
    this.isPR1Disabled = false;
    this.isPR2Disabled = true;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
  }

  toggleRegionSelection(name: string) {
    this.clearData('region');
    this.selectedRegions.set([name]);
    this.isRegionOpen = false;
    this.selectedRegion = this.selectedRegions()[0];
    this.selectedRegion = this.getRegionCodeByName(this.selectedRegion);
    this.getProductLineDetails(this.selectedRegion);
    this.isPLDisabled = false;
    this.isPR1Disabled = true;
    this.isPR2Disabled = true;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
  }


  togglePR1Selection(requestId: string) {
    const selected = this.requstList.find((req: { requestId: string; label: string }) => req.requestId === requestId) || null;
    this.selectedPR1.set(selected);
    this.isPR1Open = false;
    this.selectedRequest1 = requestId;
    this.isPR2Disabled = false;
    this.isFileUploadDisabled = false;
    this.isSubmitDisabled = true;
  }

  togglePR2Selection(requestId: string) {
    const selected = this.requstList.find((req: { requestId: string; label: string }) => req.requestId === requestId) || null;
    this.selectedPR2.set(selected);
    this.isPR2Open = false;
    this.selectedRequest2 = requestId;
    this.isSubmitDisabled = false;
  }

  getRegionCodeByName(name: string): string | undefined {
    const region = this.regions.find((r: { regionName: string; }) => r.regionName === name);
    return region?.regionCode;
  }

  getPLCodeByDescription(name: string): string | undefined {
    const pl = this.productLines.find((r: { description: string; }) => r.description === name);
    return pl?.code;
  }

  simulateUpload(): void {
    this.uploadInProgress = true;
    this.uploadProgress = 0;

    const interval = setInterval(() => {
      this.uploadProgress += 10;

      if (this.uploadProgress >= 100) {
        clearInterval(interval);
        setTimeout(() => {
          this.uploadInProgress = false;
        }, 500);
      }
    }, 300);
  }

  goToHome() {
    this.router.navigate(['/home']);
  }


  clearData(type: string) {
    if (type === 'region') {
      this.selectedProductLineIds.set([]);
      this.selectedProductLine = [];
    }
    this.requstList = [];
    this.isFileUploaded = false;
    this.errorFlag = false;
    this.fileError = '';
    this.getFileSize = null;
    this.fileName = '';
    this.selectedPR1.set(null);
    this.selectedPR2.set(null);
    if (this.fileInputRef?.nativeElement) {
      this.fileInputRef.nativeElement.value = '';
    }
    this.selectedRequest1 = '';
    this.selectedRequest2 = '';
    this.request2Type = '';
    this.displayStyle = 'none';
  }

  clearAllData() {
    // Clear all form data unconditionally when switching tabs
    this.selectedProductLineIds.set([]);
    this.selectedRegions.set([]);
    this.selectedProductLine = [];
    this.selectedRegion = '';
    this.isFileUploaded = false;
    this.errorFlag = false;
    this.fileError = '';
    this.getFileSize = null;
    this.fileName = '';
    this.selectedPR1.set(null);
    this.selectedPR2.set(null);
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
    }
    this.selectedRequest1 = '';
    this.selectedRequest2 = '';
    this.request2Type = '';
    this.displayStyle = 'none';
    this.isPLDisabled = true;
    this.isPR1Disabled = true;
    this.isPR2Disabled = true;
    this.isFileUploadDisabled = true;
    this.isSubmitDisabled = true;
  }

  downloadPriceFXFile() {
    this.downloadFileService.downloadPriceFXFile();
  }

  public fileOver(event: any) {
    //console.log(event);
  }

  public fileLeave(event: any) {
    //console.log(event);
  }


}
